import React, { useEffect, useState } from "react";
import { IoArrowBack } from "react-icons/io5";
import { FaFileInvoice } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import apiendpoints from "../../apiendpoints.json";

const Customer = () => {
  const { id } = useParams();
  const [customer, setCustomer] = useState([]);
  const [loading, setloading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setloading(true);
    const fetchCustomer = async () => {
      try {
        const response = await fetch(
          `${apiendpoints.equityUrl}/api/GetCustomerDetail`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ kyc_Id: id }),
          }
        );

        if (!response.ok) {
          throw new Error("Failed to Fetch Customer");
        }

        const data = await response.json();
        setCustomer(data);
      } catch (error) {
        if (error instanceof Error) {
          console.log(error);
        } else {
          toast.error("error");
        }
      } finally {
        setloading(false);
      }
    };
    fetchCustomer();
  }, [id]);

  function formatDate(date) {
    if (!date) return "";
    const d = new Date(date);
    if (isNaN(d.getTime())) return "";
    let year = d.getFullYear();
    let month = (d.getMonth() + 1).toString().padStart(2, "0");
    let day = d.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const handleCreateInvoice = (selectedService = null) => {
    const cust = customer[0] || {};
    const fullName = [cust.firstName, cust.middleName, cust.lastName]
      .filter(Boolean)
      .join(" ")
      .trim();

    const targetService = selectedService || cust._lstPurchaseDetails?.[0] || null;

    const prefillData = {
      customerName: fullName || "N/A",
      email: cust.emailId || "",
      phone: cust.mobileNumber || "",
      buyerPan: cust.panno || "",
      panno: cust.panno || "",
      buyerAddress: cust.address || "",
      service: targetService?.service || "",
      amount: targetService?.service_price || "",
      serviceStartDate: targetService?.serviceStartDate ? formatDate(targetService.serviceStartDate) : "",
      serviceEndDate: targetService?.serviceEndDate ? formatDate(targetService.serviceEndDate) : "",
      rmName: cust.rmName || "",
      kycId: cust.kycId || id || "",
    };

    navigate("/equity-admin-panel/invoice", {
      state: { prefill: prefillData },
    });
  };

  return (
    <section className="w-full border mt-10 max-w-7xl mx-auto rounded shadow-sm bg-white">
      <header className="flex items-center justify-between w-full border-b p-3 bg-gray-50 rounded-t">
        <div className="flex gap-4 items-center">
          <span
            className="text-black hover:scale-110 transition-transform cursor-pointer w-max"
            onClick={() => navigate("/equity-admin-panel/customers")}
            title="Back to Customers"
          >
            <IoArrowBack size={26} />
          </span>
          <h4 className="font-bold text-gray-800 text-lg">Customer Details</h4>
        </div>

        <button
          type="button"
          onClick={() => handleCreateInvoice()}
          className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-xs sm:text-sm font-semibold rounded-lg shadow-sm transition-all cursor-pointer"
          title="Create Invoice with prefilled customer data"
        >
          <FaFileInvoice size={15} />
          <span>Create Invoice</span>
        </button>
      </header>

      <div className="p-6">
        <div className="flex flex-wrap items-center gap-6 p-4 bg-gray-50 border border-gray-200 rounded-lg mb-6 text-sm">
          <p>
            <strong className="text-gray-600">Name:</strong>{" "}
            <span className="font-semibold text-gray-900">
              {([customer[0]?.firstName, customer[0]?.middleName, customer[0]?.lastName]
                .filter(Boolean)
                .join(" ") || "N/A")}
            </span>
          </p>
          <p>
            <strong className="text-gray-600">Aadhaar:</strong>{" "}
            <span className="font-mono">{customer[0]?.aadharId || "N/A"}</span>
          </p>
          <p>
            <strong className="text-gray-600">Pan No:</strong>{" "}
            <span className="font-mono uppercase font-semibold text-blue-800">
              {customer[0]?.panno || "N/A"}
            </span>
          </p>
          <p>
            <strong className="text-gray-600">Mobile:</strong>{" "}
            <span>{customer[0]?.mobileNumber || "N/A"}</span>
          </p>
          <p>
            <strong className="text-gray-600">KYC ID:</strong>{" "}
            <span className="font-mono">{customer[0]?.kycId || id || "N/A"}</span>
          </p>
          {customer[0]?.emailId && (
            <p>
              <strong className="text-gray-600">Email:</strong>{" "}
              <span className="font-mono text-blue-600">{customer[0]?.emailId}</span>
            </p>
          )}
        </div>

        <div className="overflow-x-auto border border-gray-200 rounded-lg">
          <table className="w-full border-collapse text-sm">
            <thead className="font-semibold bg-gray-100 text-gray-700 text-left">
              <tr>
                <th className="p-3 border-b">S No.</th>
                <th className="p-3 border-b">Id</th>
                <th className="p-3 border-b">Service</th>
                <th className="p-3 border-b">Duration</th>
                <th className="p-3 border-b">Start Date</th>
                <th className="p-3 border-b">End Date</th>
                <th className="p-3 border-b">Price</th>
                <th className="p-3 border-b text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {loading && (
                <tr>
                  <td colSpan={8} className="text-center py-8">
                    <div className="loader mx-auto"></div>
                  </td>
                </tr>
              )}
              {!loading && (!customer[0]?._lstPurchaseDetails || customer[0]._lstPurchaseDetails.length === 0) && (
                <tr>
                  <td colSpan={8} className="text-center py-6 text-gray-500">
                    No purchase service records found for this customer.
                  </td>
                </tr>
              )}
              {!loading &&
                customer[0]?._lstPurchaseDetails?.map((service, i) => {
                  return (
                    <tr key={service.id || i} className="hover:bg-gray-50 border-b border-gray-100 text-gray-800">
                      <td className="p-3">{i + 1}</td>
                      <td className="p-3 font-mono text-xs">{service.id}</td>
                      <td className="p-3 font-medium text-blue-900">{service.service}</td>
                      <td className="p-3">{service.service_duration}</td>
                      <td className="p-3">{formatDate(service.serviceStartDate)}</td>
                      <td className="p-3">{formatDate(service.serviceEndDate)}</td>
                      <td className="p-3 font-semibold font-mono">₹{service.service_price}</td>
                      <td className="p-3 text-center">
                        <button
                          type="button"
                          onClick={() => handleCreateInvoice(service)}
                          className="inline-flex items-center gap-1.5 px-3 py-1 bg-blue-50 hover:bg-blue-100 text-blue-700 border border-blue-200 text-xs font-semibold rounded-md shadow-xs transition-colors cursor-pointer"
                          title="Create Invoice for this specific service"
                        >
                          <FaFileInvoice size={12} />
                          <span>Create Invoice</span>
                        </button>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default Customer;
